import StorageService from '../services/storage.service';
import { LANGUAGE_CHANGE_FAILURE, LANGUAGE_CHANGE_SUCCESS } from './type';

export const changeLanguage = (language) => (dispatch) => {
  try {
    // Update local storage with the selected language
    StorageService.setObject('language', language);

    // Dispatch success action
    dispatch({
      type: LANGUAGE_CHANGE_SUCCESS,
      payload: language,
    });
  } catch {
    // Dispatch failure action
    dispatch({
      type: LANGUAGE_CHANGE_FAILURE,
    });
  }
};
